export default "__VITE_ASSET__1f110d07__"